import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import kfsyscc from '../utils/KfsysccLogo_4.svg'
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { useState } from 'react'
import Drawer from '@material-ui/core/Drawer';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BookMarkIcon from '@material-ui/icons/Bookmark';
import SearchIcon from '@material-ui/icons/Search';
import List from '@material-ui/core/List';
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    logo: {
        height: '42px',
        marginRight: '10px'
    },
    title: {
        color: theme.palette.secondary.main,
        flexGrow: 1,
        textShadow: "1px 1px 5px #000"
    },
    list: {
        width: 250
    }
}));

export default function ButtonAppBar() {

    const classes = useStyles();

    const [drawerOpen, setOpen] = useState(false)

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    let history = useHistory()

    return (
        <div className={classes.root}>
            <AppBar position="relative">
                <Toolbar>
                    <img src={kfsyscc} className={classes.logo} alt="logo" />
                    <Typography variant="h6" className={classes.title} align="center">
                        和信醫院治癌中心–癌症篩檢及成人預防保健預約系統
                    </Typography>
                    <IconButton
                        className={classes.menuButton}
                        color="secondary"
                        aria-label="menu"
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer anchor={"right"} open={drawerOpen} onClose={toggleDrawer(false)}>
                <div
                    className={classes.list}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                >
                    <List>
                        <ListItem button onClick={()=>{history.push('/')}}>
                            <ListItemIcon>
                                <BookMarkIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"預約"} />
                        </ListItem>
                        <ListItem button onClick={()=>{history.push('/search')}}>
                            <ListItemIcon>
                                <SearchIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"查詢/取消"} />
                        </ListItem>
                    </List>
                </div>
            </Drawer>
        </div>
    );
}